export const FONTS = [
  {
    key: 'Segoe UI, Segoe UI Web (West European), Roboto, Helvetica Neue, sans-serif',
    value: 'Segoe UI',
  },
  {
    key: 'Helvetica Neue, sans-serif',
    value: 'Helvetica Neue',
  },
  {
    key: 'Georgia, serif',
    value: 'Georgia',
  },
  {
    key: 'Times New Roman, Times, serif',
    value: 'Times New Roman',
  },
  {
    key: 'Arial, Helvetica, sans-serif',
    value: 'Arial',
  },
  {
    key: 'Helvetica, sans-serif',
    value: 'Helvetica',
  },
  {
    key: 'Arial Black, Gadget, sans-serif',
    value: 'Arial Black',
  },
  {
    key: 'Comic Sans MS, cursive, sans-serif',
    value: 'Comic Sans MS',
  },
  {
    key: 'Impact, Charcoal, sans-serif',
    value: 'Impact',
  },
  {
    key: 'Lucida Sans Unicode, Lucida Grande, sans-serif',
    value: 'Lucida Sans Unicode',
  },
  {
    key: 'Tahoma, Geneva, sans-serif',
    value: 'Tahoma, Geneva, sans-serif',
  },
  {
    key: 'Trebuchet MS, Helvetica, sans-serif',
    value: 'Trebuchet MS',
  },
  {
    key: 'Verdana, Geneva, sans-serif',
    value: 'Verdana',
  },
  {
    key: 'Courier New, Courier, monospace',
    value: 'Courier New',
  },
  {
    key: 'Lucida Console, Monaco, monospace',
    value: 'Lucida Console',
  },
];

export const FONT_SIZES = [
  {
    key: '8px',
    value: '8px',
  },
  {
    key: '10px',
    value: '10px',
  },
  {
    key: '12px',
    value: '12px',
  },
  {
    key: '14px',
    value: '14px',
  },
  {
    key: '16px',
    value: '16px',
  },
  {
    key: '18px',
    value: '18px',
  },
  {
    key: '20px',
    value: '20px',
  },
];

export const FONT_WEIGHTS = [
  {
    key: '100',
    value: '100',
  },
  {
    key: '200',
    value: '200',
  },
  {
    key: '300',
    value: '300',
  },
  {
    key: '400',
    value: '400',
  },
  {
    key: '500',
    value: '500',
  },
  {
    key: '600',
    value: '600',
  },
  {
    key: '700',
    value: '700',
  },
  {
    key: '800',
    value: '800',
  },
  {
    key: '900',
    value: '900',
  },
];

export const TEXT_TRANSFORMS = [
  {
    key: 'none',
    value: 'none',
  },
  {
    key: 'lowercase',
    value: 'lowercase',
  },
  {
    key: 'uppercase',
    value: 'UPPERCASE',
  },
  {
    key: 'capitalize',
    value: 'Capitalize',
  },
];

export const TEXT_ALIGN = [
  {
    key: 'left',
    value: 'left',
  },
  {
    key: 'center',
    value: 'center',
  },
  {
    key: 'right',
    value: 'right',
  },
];

export const LETTER_SPACING = [
  {
    key: '0px',
    value: '0px',
  },
  {
    key: '1px',
    value: '1px',
  },
  {
    key: '2px',
    value: '2px',
  },
  {
    key: '3px',
    value: '3px',
  },
  {
    key: '4px',
    value: '4px',
  },
  {
    key: '5px',
    value: '5px',
  },
];

export const NAVIGATOR_PADDING = [
  {
    key: '5px',
    value: '5px',
  },
  {
    key: '10px',
    value: '10px',
  },
  {
    key: '15px',
    value: '15px',
  },
  {
    key: '20px',
    value: '20px',
  },
  {
    key: '25px',
    value: '25px',
  },
];

export const INDENT = [
  {
    key: '0',
    value: '0px',
  },
  {
    key: '5',
    value: '5px',
  },
  {
    key: '10',
    value: '10px',
  },
  {
    key: '15',
    value: '15px',
  },
  {
    key: '20',
    value: '20px',
  },
  {
    key: '25',
    value: '25px',
  },
  {
    key: '30',
    value: '30px',
  },
];

export const LINE_THICKNESS = [
  {
    key: '1px',
    value: '1px',
  },
  {
    key: '2px',
    value: '2px',
  },
  {
    key: '3px',
    value: '3px',
  },
  {
    key: '4px',
    value: '4px',
  },
  {
    key: '5px',
    value: '5px',
  },
];



export const ELEMENT_TYPES = [
  {
    key: 'link',
    value: 'Link',
  },
  {
    key: 'image',
    value: 'Image',
  },
  {
    key: 'video',
    value: 'Video',
  },
  {
    key: 'text',
    value: 'Text',
  },
];

export const TOP_ITEM_TYPES = [
  {
    key: 'menu',
    value: 'Menu/Link',
  },
  {
    key: 'phonebook',
    value: 'Phonebook',
  },
  {
    key: 'event',
    value: 'Event',
  },
  {
    key: 'contentcreator',
    value: 'Content Creator',
  },
  {
    key: 'peoplefinder',
    value: 'People Finder',
  },
];

export const SMARTMENU_TOP_ITEM_TYPES = [
  {
    key: 'menu',
    value: 'Menu/Link',
  },
  {
    key: 'phonebook',
    value: 'Phonebook',
  },
  {
    key: 'event',
    value: 'Event',
  },
  {
    key: 'contentcreator',
    value: 'Content Creator',
  },
  {
    key: 'peoplefinder',
    value: 'People Finder',
  },
  {
    key: 'celebration',
    value: 'Celebration',
  },
  {
    key: 'pagetranslation',
    value: 'Page Translation'
  }
];

export const SMARTMENU_TOP_ITEM_CODE_SNIPPET = [
  {
    key: 'code',
    value: 'Code snippet',
  }
];

export const SMARTMENU_TOP_ITEM_AI = [
  {
    key: 'ai',
    value: 'AI assistent',
  }
];

export const SMARTMENU_TOP_ITEM_TARGETED_PREVIEW = [
  {
    key: 'targetedPreview',
    value: "Targeted preview"
  }
];

export const SHOW_PERIOD = [
  {
    key: 'upcomming',
    value: 'Upcoming',
  },
  {
    key: 'fullView',
    value: 'FullView',
  },
  {
    key: 'day',
    value: 'Day',
  },
  {
    key: 'week',
    value: 'Week',
  },
  {
    key: 'month',
    value: 'Month',
  },
];

// Maps each built-in image confetti template's key to the localization keys for its title/
// infobox text, so TopItemSettingsPanel can show translated text (falling back to the Danish
// literals below in IMAGE_CONFETTI_TEMPLATES when no translation is set in the localization DB).
export const IMAGE_CONFETTI_TEMPLATE_LOCALIZATION_KEYS: { [templateKey: string]: { title: string; headline: string; message: string } } = {
  halloween: {
    title: "Navigator_ConfettiTemplate_Halloween_Title",
    headline: "Navigator_ConfettiTemplate_Halloween_InfoboxHeadline",
    message: "Navigator_ConfettiTemplate_Halloween_InfoboxMessage",
  },
  christmas: {
    title: "Navigator_ConfettiTemplate_Christmas_Title",
    headline: "Navigator_ConfettiTemplate_Christmas_InfoboxHeadline",
    message: "Navigator_ConfettiTemplate_Christmas_InfoboxMessage",
  },
  valentine: {
    title: "Navigator_ConfettiTemplate_Valentine_Title",
    headline: "Navigator_ConfettiTemplate_Valentine_InfoboxHeadline",
    message: "Navigator_ConfettiTemplate_Valentine_InfoboxMessage",
  },
  birthday: {
    title: "Navigator_ConfettiTemplate_Birthday_Title",
    headline: "Navigator_ConfettiTemplate_Birthday_InfoboxHeadline",
    message: "Navigator_ConfettiTemplate_Birthday_InfoboxMessage",
  },
  fall: {
    title: "Navigator_ConfettiTemplate_Fall_Title",
    headline: "Navigator_ConfettiTemplate_Fall_InfoboxHeadline",
    message: "Navigator_ConfettiTemplate_Fall_InfoboxMessage",
  },
};

// Ready-made image sets an admin can apply to an "imageconfetti" celebration in one click.
export const IMAGE_CONFETTI_TEMPLATES = [
  {
    key: 'halloween',
    title: 'Halloween',
    imageUrls: [
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/halloween/pumpkin.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/halloween/ghost.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/halloween/bat.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/halloween/candy.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/halloween/dracula.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/halloween/frankenstein.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/halloween/ghost-green.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/halloween/skull-and-bones.png',
    ],
    showConfettiInfobox: true,
    confettiInfoboxHeadline: 'Gyseligt godt Halloween!',
    confettiInfoboxMessage: 'Held og lykke med slikjagten - pas på spøgelserne!',
    confettiInfoboxBackgroundColor: '#2b1a3e',
    confettiInfoboxTextColor: '#ff8c00',
  },
  {
    key: 'christmas',
    title: 'Christmas',
    imageUrls: [
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/christmas/christmas-wreath.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/christmas/gingerbread.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/christmas/star.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/christmas/bauble.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/christmas/gift-box.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/christmas/christmas-bell.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/christmas/hat.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/christmas/christmas-tree.png',
    ],
    showConfettiInfobox: true,
    confettiInfoboxHeadline: 'Glædelig jul!',
    confettiInfoboxMessage: 'Vi ønsker jer alle en rigtig glædelig jul og et godt nytår.',
    confettiInfoboxBackgroundColor: '#1b4332',
    confettiInfoboxTextColor: '#ffffff',
  },
  {
    key: 'valentine',
    title: 'Valentine',
    imageUrls: [
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/valentine/heart.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/valentine/heart-pink.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/valentine/heart-purple.png',
    ],
    showConfettiInfobox: true,
    confettiInfoboxHeadline: 'Glædelig Valentinsdag!',
    confettiInfoboxMessage: 'Husk at fortælle nogen, hvor meget de betyder for dig i dag.',
    confettiInfoboxBackgroundColor: '#ffe0e9',
    confettiInfoboxTextColor: '#b3005e',
  },
  {
    key: 'birthday',
    title: 'Fødselsdag',
    imageUrls: [
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/birthday/flag.png',
    ],
    showConfettiInfobox: true,
    confettiInfoboxHeadline: 'Tillykke med fødselsdagen til xxx!',
    confettiInfoboxMessage: 'Vi håber, du får en fantastisk dag!',
    confettiInfoboxBackgroundColor: '#efa5a8',
    confettiInfoboxTextColor: '#1b1b1b',
  },
  {
    key: 'fall',
    title: 'Efterår',
    imageUrls: [
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/fall/leaf-2.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/fall/leaf.png',
      'https://intraactivestorage.blob.core.windows.net/cdn/confetti/fall/tropical-leaves.png',
    ],
    showConfettiInfobox: true,
    confettiInfoboxHeadline: 'Velkommen til efteråret',
    confettiInfoboxMessage: 'Nyd de farverige blade og den hyggelige stemning.',
    confettiInfoboxBackgroundColor: '#ebd996',
    confettiInfoboxTextColor: '#4f4c34',
  },
];

export const enum UserRole {
  none = 0,
  reader = 1,
  editor = 2,
  administrator = 3,
  contributor = 4,
}
